import { Component, ElementRef, Input, OnInit, OnDestroy, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { MerchandWhitelistService } from 'src/app/services/merchand-whitelist.service';
import { NzModalService } from 'ng-zorro-antd';
import { forkJoin, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MerchandWhitelist } from 'src/app/settings/interfaces/MerchandWhitelist';

@Component({
  selector: 'app-merchant-whitelist',
  templateUrl: './merchant-whitelist.component.html',
  styleUrls: ['./merchant-whitelist.component.scss']
})
export class MerchantWhitelistComponent implements OnInit, OnDestroy {
  @ViewChild('modalContent', { static: true }) modalContent!: TemplateRef<any>;
  @Input() merchantT!: string;

  merchant = this.aR.snapshot.paramMap.get('id') ? this.aR.snapshot.paramMap.get('id') : null;

  whitelistForm: FormGroup;
  whitelistDomains: MerchandWhitelist[] | any = [];

  editIndex: number | null = null;
  editCache: string = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    public whitelistService: MerchandWhitelistService,
    private modal: NzModalService,
    private aR: ActivatedRoute
  ) {
    this.whitelistForm = this.fb.group({
      merchantId: ['', Validators.required],
      domains: this.fb.array([])
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['merchantT']?.currentValue && changes['merchantT'].previousValue !== changes['merchantT'].currentValue) {
      this.addDomain();
      this.recoverWhitelist();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  get domains(): FormArray {
    return this.whitelistForm.get('domains') as FormArray;
  }

  addDomain(): void {
    const domainGroup = this.fb.group({
      whitelist: ['', [Validators.required, Validators.pattern(
        /^(?:(?:https?:\/\/)?(?:www\.)?(([\w-]+\.)+[\w-]{2,}|(\d{1,3}\.){3}\d{1,3}))$/
      )]]
    });
    this.domains.push(domainGroup);
  }

  removeDomainFromForm(index: number): void {
    this.domains.removeAt(index);
  }

  startEdit(index: number): void {
    this.editIndex = index;
    this.editCache = this.whitelistDomains[index].whitelist;
  }

  saveEdit(index: number): void {
    const item = this.whitelistDomains[index];
    if (this.editCache.trim()) {
      const sub = this.whitelistService.update(item.MerchandWhitelistID, { whitelist: this.editCache.trim() })
        .subscribe({
          next: (res) => {
            this.whitelistDomains[index].whitelist = res.whitelist;
            this.editIndex = null;
            this.recoverWhitelist();

          },
          error: (err) => {

           }
        });
      this.subscriptions.push(sub);
    } else {
      this.cancelEdit();
    }
  }

  cancelEdit(): void {
    this.editIndex = null;
  }

  deleteDomain(index: number): void {
    const item = this.whitelistDomains[index];
    const sub = this.whitelistService.delete(item.MerchandWhitelistID)
      .subscribe({
        next: () => this.whitelistDomains.splice(index, 1),
        error: () => {}
      });
    this.subscriptions.push(sub);
  }

  submit(): void {
    if (this.whitelistForm.valid) {
      const merchantId = this.whitelistForm.value.merchantId;
      const domains = this.whitelistForm.value.domains.map((d: any) => d.whitelist.trim());

      const requests = domains.map(domain =>
        this.whitelistService.create({ MerchantID: merchantId, whitelist: domain })
      );

      const sub = forkJoin(requests).subscribe({
        next: (responses) => {
          this.whitelistDomains = [...this.whitelistDomains, ...responses];
          this.modal.closeAll();
          this.modal.success({
            nzTitle: 'Creación exitosa',
            nzContent: 'Whitelist creada correctamente'
          });

          this.whitelistForm.reset({ merchantId, domains: [] });
          this.recoverWhitelist();
        },
        error: (err) => {

        }
      });
      this.subscriptions.push(sub);
    }
    


  }


    openModal(): void {
    this.modal.create({
      nzTitle: 'WhiteList',
      nzContent: this.modalContent,
      nzFooter: null,
      nzWidth: 500
    });
  }

  recoverWhitelist(): void {
    this.whitelistDomains = [];

    if (this.merchant) {
      const sub = this.whitelistService.getMerchantDetail(this.merchant).subscribe({
        next: (response) => {
          const merchantId = Number(response.data[0].merchantID);
          this.whitelistForm.patchValue({ merchantId });

          const subInner = this.whitelistService.getById(merchantId).subscribe({
            next: (response) => {
              this.whitelistDomains = response.data;
            },
            error: (err) => {
              this.whitelistDomains = [];
            }
          });
          this.subscriptions.push(subInner);
        },
        error: (err) => {
          this.whitelistDomains = [];
        }
      });

      this.subscriptions.push(sub);
    }
  }
}
